import { css } from 'styled-components';
import { UiColors } from 'assets/styles/old/global';

/**
 * Fill + text colours for anything that renders a tag (tile chips, the option-list rows), so the two
 * kinds of tag are told apart at a glance. Reuses the ui-kit Button palettes, so the pair reads as the
 * app's primary/secondary buttons rather than two new colours:
 *   - custom tag (`form: null`)      — mango fill (#FFB68C) on forest text — the PRIMARY scheme
 *   - form-linked tag (`form: <id>`) — forest fill on peach text          — the SECONDARY scheme
 *
 * Drives off the `formLinked` prop; feed it isFormLinkedTag(tag) from mediaTagsStore.
 */
const tagPalette = ({ formLinked }) =>
  formLinked
    ? css`
        background: ${UiColors.forestColor};
        color: ${UiColors.peachColor};
      `
    : css`
        background: ${UiColors.mangoColor};
        color: ${UiColors.forestColor};
      `;

export default tagPalette;
